<div class="gestion-listas-page mat-app-background">
    <div class="container-fluid">
        <div class="panel-grid mt-2" #panelContainer [style.grid-template-columns]="gridTemplateColumns">
          <div class="panel-area">
            <mat-card class="mb-2 enrolled-created-box ccorbit-card no-scrollbar" style="height: calc(100vh - 96px); min-height: 560px;">
                    <mat-card-content class="">
                        <div class="row">
                            <div class="col-4">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Seleccione Mercado</mat-label>
                  <mat-select [(ngModel)]="selectedValue" name="food"
                    [disabled]="isLoadingMercado"
                                        (selectionChange)="buscarCompania()">
                                        <mat-option *ngFor="let merc of mercado" [value]="merc.idmercado"


                                            [class.mat-selected]="merc.idmercado === selectedValue"
                                            [class.first-option]="true">{{merc.iso}} {{merc.metaapi ? '(MetaApi)' : ''}} ({{merc.activos}})</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
              <div class="col-7">
                <mat-form-field style="width: 100%;">
                  <mat-label>Buscar</mat-label>
                  <input matInput (keyup)="applyFilter($event)" placeholder="Ex. mercado:nasdaq" #input
          [disabled]="isLoadingMercado">
                  <button mat-icon-button matSuffix type="button"
                    matTooltip="Ver ayuda de filtros"
                    (click)="showFilterHelp()">
                    <mat-icon>help_outline</mat-icon>
                  </button>
                </mat-form-field>
                            </div>
                            <div class="col-1">
                                <button mat-icon-button 
                                        matTooltip="Copiar datos para Excel"
                                        (click)="copyToExcel()">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            </div>
                        </div>
            <mat-progress-bar *ngIf="isLoadingMercado" mode="indeterminate" color="accent"></mat-progress-bar>
            <div class="table-container" *ngIf="companias">
                            <cdk-virtual-scroll-viewport #viewportGestion id="viewportGestion" item [appendOnly]="false"
                                [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
                                <table cdk-table [dataSource]="companias" class="table-striped tableStyle">
                                  <ng-container cdkColumnDef="select">
                                    <th cdk-header-cell *cdkHeaderCellDef class="check-column sticky-header"> <!-- sin sort para checkbox --> 
                                      <mat-checkbox class="compact-checkbox" (change)="$event ? masterToggle() : null"
                                                    [checked]="isAllSelected()"
                                                    [indeterminate]="selectedRows.length > 0 && !isAllSelected()">
                                      </mat-checkbox>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let row" class="check-column">
                                      <mat-checkbox class="compact-checkbox" (click)="$event.stopPropagation()"
                                                    (change)="$event ? toggleSelection(row) : null"
                                                    [checked]="isSelected(row)">
                                      </mat-checkbox>
                                    </td>
                                  </ng-container>

                                    <ng-container cdkColumnDef="n">
                                    <th cdk-header-cell *cdkHeaderCellDef class="contador-column sticky-header" style="width: 30px;"
                                      (click)="sortBy('n')" [class.sorted]="sortState.active === 'n'">
                                      #.
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'n'">
                                      {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element" class="contador-column" style="width: 30px;"> {{element.n}} </td>
                                    </ng-container>

                                  <ng-container cdkColumnDef="iso">
                                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"
                                        (click)="sortBy('iso')" [class.sorted]="sortState.active === 'iso'">
                                      Compañia
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'iso'">
                                        {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element" class="first-column">
                                      {{element.iso}} {{element.secType === 'CFD' ? 'CFD' : ''}}
                                    </td>
                                  </ng-container>

                                  <ng-container cdkColumnDef="descripcion">
                                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"
                                        (click)="sortBy('descripcion')" [class.sorted]="sortState.active === 'descripcion'">
                                      Descripcion
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'descripcion'">
                                        {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element"> {{element.descripcion}} </td>
                                  </ng-container>

                                  <ng-container cdkColumnDef="tipo">
                                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"
                                        (click)="sortBy('tipo')" [class.sorted]="sortState.active === 'tipo'">
                                      Tipo
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'tipo'">
                                        {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element" class="first-column"> {{element.tipo}} </td>
                                  </ng-container>

                                  <ng-container cdkColumnDef="secType">
                                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"
                                        (click)="sortBy('secType')" [class.sorted]="sortState.active === 'secType'">
                                      SecType
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'secType'">
                                        {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element" class="first-column"> {{element.secType}} </td>
                                  </ng-container>

                                  <ng-container cdkColumnDef="mercado">
                                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"
                                        (click)="sortBy('mercado')" [class.sorted]="sortState.active === 'mercado'">
                                      Mercado
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'mercado'">
                                        {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element" class="first-column"> {{element.mercado}} </td>
                                  </ng-container>

                                    <ng-container cdkColumnDef="tradingcurrency">
                                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header currency-column"
                                      (click)="sortBy('tradingcurrency')" [class.sorted]="sortState.active === 'tradingcurrency'">
                                      <mat-icon>currency_exchange</mat-icon>
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'tradingcurrency'">
                                      {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element" class="currency-column"> {{element.tradingcurrency}} </td>
                                    </ng-container>

                                  <ng-container cdkColumnDef="precioteorico">
                                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header price-double"
                                        (click)="sortBy('precioteorico')" [class.sorted]="sortState.active === 'precioteorico'" >
                                      Cotizacion
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'precioteorico'">
                                        {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element" class="price-double">
                                      <a [href]="urlMercadoActivo(element)" target="_blank">{{element.precioteorico | number:'1.2-2'}} <mat-icon>open_in_new</mat-icon> </a>
                                      <a href="https://site.financialmodelingprep.com/financial-summary/{{element.iso}}" target="_blank"> <mat-icon>open_in_new</mat-icon> </a>
                                    </td>
                                  </ng-container>

                                  <ng-container cdkColumnDef="volumen">
                                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"
                                        (click)="sortBy('volumen')" [class.sorted]="sortState.active === 'volumen'">
                                      Volumen
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'volumen'">
                                        {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element" class="first-column">
                                      {{element.volumen | number:'1.0-0'}}
                                    </td>
                                  </ng-container>

                                  <ng-container cdkColumnDef="broker" >
                                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"
                                        (click)="sortBy('broker')" [class.sorted]="sortState.active === 'broker'"
                                        [style.width]="metaapi ? '0' : ''" [style.padding]="metaapi ? '0' : ''" [style.overflow]="metaapi ? 'hidden' : ''">
                                      Broker IBKR
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'broker'">
                                        {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element" class="first-column"
                                        [style.width]="metaapi ? '0' : ''" [style.padding]="metaapi ? '0' : ''" [style.overflow]="metaapi ? 'hidden' : ''">
                                      <span *ngIf="element.conid && !metaapi" class="broker-tag conid-tag">ID</span>
                                      <span *ngIf="element.conidcfd && !metaapi" class="broker-tag cfd-tag">CFD</span>
                                    </td>
                                  </ng-container>
                                  <ng-container cdkColumnDef="contractsize" >
                                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"
                                        (click)="sortBy('contractsize')" [class.sorted]="sortState.active === 'contractsize'">
                                      Contract Size
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'contractsize'">
                                        {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element" class="first-column">
                                      <ng-container *ngIf="metaapi">{{ element.contractsize | number:'1.0-0' }}</ng-container>
                                      <ng-container *ngIf="!metaapi">{{ 1 | number:'1.0-0' }}</ng-container>
                                      
                                    </td>
                                  </ng-container>

                                  <ng-container cdkColumnDef="dias">
                                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"
                                        (click)="sortBy('dias')" [class.sorted]="sortState.active === 'dias'">
                                      Dias
                                      <mat-icon class="sort-icon" *ngIf="sortState.active === 'dias'">
                                        {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
                                      </mat-icon>
                                    </th>
                                    <td cdk-cell *cdkCellDef="let element" class="first-column">
                                      {{ element.dias === -1 ? '-' : (element.dias | number:'1.2-2') }}
                                    </td>
                                  </ng-container>

                                  <tr cdk-header-row *cdkHeaderRowDef="columnasVisibles; sticky: true" class="sticky-header"></tr>
                                  <tr cdk-row *cdkRowDef="let row; columns: columnasVisibles;"></tr>
                                </table>

                            </cdk-virtual-scroll-viewport>

                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="divider-area" #dividerColumn>
              <mat-card class="mb-2 enrolled-created-box ccorbit-card no-scrollbar" style="height: 100%;">
                <mat-card-content class="center-content">
                  <button class="botones" (click)="enviarDatos()" matTooltip="Enviar selección">
                      <mat-icon>chevron_right</mat-icon>
                  </button>
                </mat-card-content>
              </mat-card>
              <div class="drag-handle drag-handle--left" (mousedown)="startResize($event)"></div>
              <div class="drag-handle drag-handle--right" (mousedown)="startResize($event)"></div>
            </div>
            <div class="panel-area">
              <mat-card class="mb-2 enrolled-created-box ccorbit-card no-scrollbar" style="height: 100%;">
                    <mat-card-content class="">
                        <mat-tab-group [selectedIndex]="selectedTabIndex"
                            (selectedTabChange)="onTabChange($event)">

                            <mat-tab label="Generar Listas">
                                <app-lista-compania  [currentlistcfd]="currentlistcfd" [metaapi]="metaapi" [mercado]="mercadoSeleccionado"></app-lista-compania>
                            </mat-tab>
                            <mat-tab label="Eliminar Listas">
                                <app-eliminar-lista></app-eliminar-lista>
                            </mat-tab>

                            <mat-tab label="Editar Listas">
                                <app-editar-lista
                                    [currentlistcfd]="currentlistcfd" [metaapi]="metaapi"
                                    [idMercadoInicial]="idMercadoEditar"
                                    (save)="onSaveEdit($event)">
                                </app-editar-lista>
                            </mat-tab>
                        </mat-tab-group>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>

  <ng-template #filterHelpTemplate>
    <h2 mat-dialog-title>Ayuda de filtros</h2>
    <mat-dialog-content>
      <p>Puedes combinar varios criterios separados por espacios. Ejemplos:</p>
      <ul>
        <li><code>compania:AAPL</code> filtra por símbolo.</li>
        <li><code>descripcion:BITcoin</code>filtra por descripción.</li>
        <li><code>mercado:NASDAQ</code> limita a un mercado.</li>
        <li><code>tipo:stock</code> filtra por tipo de instrumento.</li>
        <li><code>volumen&gt;1000000</code> compara valores numéricos.</li>
        <li><code>cotizacion&lt;50</code> aplica rangos de precio.</li>
      </ul>
      <p>Si escribes sin prefijo, se busca dentro de la columna Compania.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cerrar</button>
    </mat-dialog-actions>
  </ng-template>
</div>    